import Vue from 'vue'
import { newGUID } from '@/util/guid'
import {
  authenticateUser,
  createProcess,
  fetchBLH,
  fetchEquipments,
  fetchProcess,
  syncProcess,
  isAuthenticated,
  setProcess,
  setImage,
  logoutUser,
  fetchImage,
  fetchUserBlhs,
  deleteImage,
  saveFile,
  fetchConfig,
  fetchAreas
} from '../api'

const logRequests = process.env.DEBUG_MODE
export default {
  CREATE_AREA: ({ commit, dispatch, state }, area) => {
    let newArea = Object.assign({}, area)
    let proc = state.certificationProcess
    if (!proc.areas || proc.areas.length <= 0) {
      Vue.set(proc, 'areas', [])
      newArea.id = 0
      proc.status = 2
    } else {
      newArea.id = proc.areas.length
    }

    if (proc.status > 4) proc.status = 4

    proc.areas.push(newArea)
    return dispatch('SET_PROCESS', proc)
  },
  SET_AREA: ({ commit, dispatch, state }, { area, key }) => {
    let newArea = Object.assign({}, area)
    let proc = state.certificationProcess
    Vue.set(proc.areas, key, newArea)
    return dispatch('SET_PROCESS', proc)
  },
  REMOVE_AREA: ({ commit, dispatch, state }, key) => {
    let proc = state.certificationProcess
    proc.areas.splice(key, 1)
    if (proc.areas.length <= 0) {
      proc.status = 1
    } else {
      // verify if all areas status equals 1 and se it to 5
      let allAreasDone = true
      for (let i = 0; i < proc.areas.length; i++) {
        let area = proc.areas[i]
        if (area.status == null || area.status === 0) allAreasDone = false
      }
      if (allAreasDone) {
        proc.status = 5
      }
    }
    commit('SET_CURRENT_PHOTO_AREA', 0)
    return dispatch('SET_PROCESS', proc)
  },
  CREATE_STRUCTURE: ({ commit, dispatch, state }, { structure, areaKey }) => {
    let proc = state.certificationProcess
    structure.id = newGUID()
    if (
      !proc.areas[areaKey].structures ||
      proc.areas[areaKey].structures.length <= 0
    ) {
      Vue.set(proc.areas[areaKey], 'structures', [])
    }
    if (proc.status < 3) {
      proc.status = 3
    } else {
      proc.status = 4
    }
    proc.areas[areaKey].status = 0 // aways reset area status uppon adding new equipments
    proc.areas[areaKey].structures.push(structure)
    return dispatch('SET_PROCESS', proc)
  },
  SET_STRUCTURE: (
    { dispatch, state },
    { structure, areaKey, structureKey }
  ) => {
    console.log('set strucure...')
    console.log(structure, areaKey, structureKey)
    let proc = state.certificationProcess
    proc.areas[areaKey].structures[structureKey] = structure
    // Vue.set(proc.areas[areaKey], key, structure)
    return dispatch('SET_PROCESS', proc)
  },
  STRUCTURE_SYNC: ({ dispatch, state }, { itemId, areaId, status, type }) => {
    let proc = state.certificationProcess
    if (type === 'vertice') {
      Vue.set(proc.areas[areaId].vertices[itemId], 'status', status)
    } else {
      Vue.set(proc.areas[areaId].structures[itemId], 'status', status)
    }
    return dispatch('SET_PROCESS', proc)
  },
  PHOTO_SYNC: (
    { dispatch, state },
    { photoId, areaId, itemId, type, status, image, url }
  ) => {
    let proc = state.certificationProcess

    if (type === 'vertice') {
      proc.areas[areaId].vertices[itemId].photos[photoId].status = status
      Vue.set(
        proc.areas[areaId].vertices[itemId].photos[photoId],
        'status',
        status
      )
      if (url) {
        proc.areas[areaId].vertices[itemId].photos[photoId].url = url
        Vue.set(
          proc.areas[areaId].vertices[itemId].photos[photoId],
          'url',
          url
        )
      }
    } else {
      proc.areas[areaId].structures[itemId].photos[photoId].status = status
      Vue.set(
        proc.areas[areaId].structures[itemId].photos[photoId],
        'status',
        status
      )
      if (url) {
        proc.areas[areaId].structures[itemId].photos[photoId].url = url
        Vue.set(
          proc.areas[areaId].structures[itemId].photos[photoId],
          'url',
          url
        )
      }
    }

    if (status === 2) {
      console.log('not deleting image!!! change this before production')
      return deleteImage(image).then(() => {
        return dispatch('SET_PROCESS', proc)
      })
    } else {
      return dispatch('SET_PROCESS', proc)
    }
  },
  REMOVE_STRUCTURE: ({ dispatch, state }, { areaKey, key }) => {
    let proc = state.certificationProcess
    proc.areas[areaKey].structures.splice(key, 1) // removes the structure
    // check if the area has all photos taken alredy
    let vertices = proc.areas[areaKey].vertices
    let completed = true
    vertices.forEach((item) => {
      if (item.status !== 1) {
        completed = false
      }
    })
    if (completed) {
      proc.areas[areaKey].status = 1
    } else {
      proc.areas[areaKey].status = 0
    }

    // check if there is no structure added to the blh
    let structuresQty = 0
    let areasCompleted = true
    proc.areas.forEach((area) => {
      if (area.structures) {
        structuresQty += area.structures.length
      }

      if (area.status < 1) {
        areasCompleted = false
      }
    })

    if (structuresQty <= 0) {
      // if there is no structure we rollback to status 2 (waiting for equipment insertion)
      proc.status = 2
    } else if (areasCompleted && proc.status < 5) {
      proc.status = 5 // if all areas are completed we can proceed to the next step
    }

    return dispatch('SET_PROCESS', proc)
  },
  UPLOAD_FILE: ({ dispatch, state }, { image, name }) => {
    console.log(image)
    return saveFile(image, name)
      .then((url) => {
        return Promise.resolve(url)
      })
      .catch((err) => {
        console.log(err)
        return Promise.reject(new Error(err))
      })
  },
  ADD_IMAGE: ({ dispatch, state }, image) => {
    let imageId = newGUID()
    return setImage(imageId, image)
      .then(() => {
        return Promise.resolve(imageId)
      })
      .catch((err) => {
        throw err
      })
  },
  SET_IMAGE: ({ dispatch, state }, { id, image }) => {
    return setImage(id, image)
      .then(() => {
        return Promise.resolve(id)
      })
      .catch((err) => {
        throw err
      })
  },
  FETCH_IMAGE: ({ dispatch, state }, imageId) => {
    return fetchImage(imageId)
  },
  SET_PHOTO: (
    { dispatch, state },
    { areaKey, type, structureKey, photoKey, image }
  ) => {
    let proc = state.certificationProcess
    if (type === 'vertice') {
      Vue.set(
        proc.areas[areaKey].vertices[structureKey].photos[photoKey],
        'image',
        image
      )
      Vue.set(
        proc.areas[areaKey].vertices[structureKey].photos[photoKey],
        'status',
        1
      )
    } else {
      Vue.set(
        proc.areas[areaKey].structures[structureKey].photos[photoKey],
        'image',
        image
      )
      Vue.set(
        proc.areas[areaKey].structures[structureKey].photos[photoKey],
        'status',
        1
      )
    }

    let emptyPhotos = 0
    for (let areaIndex = 0; areaIndex < proc.areas.length; areaIndex++) {
      let area = proc.areas[areaIndex]
      let emptyArea = 0

      if (area.structures) {
        for (
          let structureIndex = 0;
          structureIndex < area.structures.length;
          structureIndex++
        ) {
          let structure = area.structures[structureIndex]
          let structurePhotos = 0
          if (structure.photos) {
            for (
              let photoIndex = 0;
              photoIndex < structure.photos.length;
              photoIndex++
            ) {
              let photo = structure.photos[photoIndex]
              if (!photo.image || photo.image === '') {
                emptyPhotos += 1
                emptyArea += 1
                structurePhotos += 1
              }
            }
            if (structurePhotos <= 0) {
              Vue.set(
                proc.areas[areaIndex].structures[structureIndex],
                'status',
                1
              )
            }
          }
        }
      }

      if (area.vertices) {
        for (
          let verticeIndex = 0;
          verticeIndex < area.vertices.length;
          verticeIndex++
        ) {
          let vertice = area.vertices[verticeIndex]
          let verticePhotos = 0
          if (vertice.photos) {
            for (
              let photoIndex = 0;
              photoIndex < vertice.photos.length;
              photoIndex++
            ) {
              let photo = vertice.photos[photoIndex]
              if (!photo.image || photo.image === '') {
                emptyPhotos += 1
                emptyArea += 1
                verticePhotos += 1
              }
            }
            if (verticePhotos <= 0) {
              Vue.set(
                proc.areas[areaIndex].vertices[verticeIndex],
                'status',
                1
              )
            } else {
              Vue.set(
                proc.areas[areaIndex].vertices[verticeIndex],
                'status',
                0
              )
            }
          }
        }
      }

      if (emptyArea <= 0) {
        Vue.set(proc.areas[areaIndex], 'status', 1)
      } else {
        // IF we set a photo and the are was alrady synced we need to sync it again
        if (proc.areas[areaIndex].status > 1) {
          Vue.set(proc.areas[areaIndex], 'status', 1)
        }
      }
    }
    if (emptyPhotos <= 0) {
      proc.status = 5
    } else {
      proc.status = 4
    }
    return dispatch('SET_PROCESS', proc)
  },
  FETCH_PROCESS: ({ commit, state }, { blhId, year }) => {
    return state.certificationProcess
      ? Promise.resolve(state.certificationProcess)
      : fetchProcess(year, blhId).then((proc) => {
        commit('SET_PROCESS', proc)
        if (proc) {
          commit('SET_STEP', proc.status)
        } else {
          commit('SET_STEP', 0)
        }
        return Promise.resolve(proc)
      }).catch(() => {
        commit('SET_STEP', 0)
        return Promise.resolve()
      })
  },
  CREATE_PROCESS: ({ commit, state }) => {
    return createProcess(state.blh.currentYear, state.blh.id).then((proc) => {
      commit('SET_PROCESS', proc)
      return Promise.resolve(proc)
    })
  },
  SET_PROCESS: ({ commit, state }, process) => {
    let newproc = Object.assign({}, process)
    return setProcess(state.blh.currentYear, state.blh.id, newproc).then(
      (proc) => {
        commit('SET_PROCESS', proc)
        return Promise.resolve(proc)
      }
    )
  },
  SYNC_PROCESS: ({ commit, state }, blueprintUrl) => {
    let proc = state.certificationProcess
    proc.blueprintUrl = blueprintUrl
    proc.status = 7
    return syncProcess(state.blh.currentYear, state.blh.id, proc).then(
      (proc) => {
        commit('SET_PROCESS', proc)
        return Promise.resolve(proc)
      }
    )
  },
  SYNC_TEMP_PROCESS: ({ commit, state }, process) => {
    let newProc = Object.assign({}, process)
    return syncProcess(state.blh.currentYear, state.blh.id, newProc).then(
      (proc) => {
        commit('SET_PROCESS', proc)
        return Promise.resolve(proc)
      }
    )
  },
  SET_BLH: ({ commit, state }, { blh }) => {
    console.log('SETTING BLH:', blh)
    commit('SET_BLH', blh)
    return Promise.resolve(blh)
  },
  FETCH_BLH: ({ commit, state }, { uid }) => {
    return state.blh
      ? Promise.resolve(state.blh)
      : fetchBLH(uid).then((blh) => {
        console.log('FETCHED BLH:', blh)
        commit('SET_BLH', blh)
        return Promise.resolve(blh)
      })
  },
  FETCH_USER_BLHS: ({ commit, state }) => {
    return fetchUserBlhs(state.uid)
  },
  FETCH_DATA: ({ dispatch, state }) => {
    // return dispatch('FETCH_BLH', { uid: state.uid }).then(() => {
    let promises = []
    let params = {
      blhId: state.blh.id,
      administratorId: state.blh.administratorId,
      year: state.blh.currentYear
    }
    promises.push(dispatch('FETCH_PROCESS', params))
    promises.push(dispatch('FETCH_EQUIPMENT_LIST', params))
    promises.push(dispatch('FETCH_AREAS'))
    return Promise.all(promises)
    // })
  },
  FETCH_EQUIPMENT_LIST: ({ commit, state }) => {
    return state.equipmentList[0]
      ? Promise.resolve(state.equipmentList)
      : fetchEquipments().then((eq) => {
        commit('SET_EQUIPMENT_LIST', eq)
        return Promise.resolve(eq)
      })
  },
  LOGIN: ({ commit, state }, credentials) => {
    commit('LOGIN')
    return authenticateUser(credentials.email.toLowerCase(), credentials.password).then(
      (uid) => {
        commit('LOGIN_SUCCESS', uid)
        logRequests && console.log('login success...')
        return Promise.resolve(uid)
      }
    )
  },
  LOGOUT: ({ commit, state }) => {
    commit('LOGOUT')
    return logoutUser()
  },
  CURRENT_USER: ({ commit, state }) => {
    return isAuthenticated().then((uid) => {
      commit('LOGIN_SUCCESS', uid)
      return Promise.resolve(uid)
    })
  },
  GOTO_STEP: ({ commit }, step) => {
    commit('GOTO_STEP', step)
  },
  SET_PHOTO_AREA: ({ commit }, areaIndex) => {
    commit('SET_CURRENT_PHOTO_AREA', areaIndex)
  },
  SET_PHOTO_TYPE: ({ commit }, type) => {
    commit('SET_CURRENT_PHOTO_TYPE', type)
  },
  FETCH_CONFIG: ({ commit }, config) => {
    return fetchConfig(config)
  },
  FETCH_AREAS: ({ commit, state }) => {
    return state.areasList[0]
      ? Promise.resolve(state.areasList)
      : fetchAreas().then((areas) => {
        commit('SET_AREAS_LIST', areas)
        return Promise.resolve(areas)
      })
  },
  SET_CONTINUE_WITH_MINIMUM: ({ commit }) => {
    console.log('SET_CONTINUE_WITH_MINIMUM')
    commit('SET_CONTINUE_WITH_MINIMUM')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js